import { useClearPageTopBarActions } from '@/app/layouts/pageTopBar';

/** Clears inherited TopBar actions — settings manage actions in-content. */
export function SettingsTopBarClear() {
  useClearPageTopBarActions();
  return null;
}
